/** @format */

/* eslint-disable */
import React, { useState, useEffect } from 'react'
import localize from '../../../../../../../Global/Localize'
import { getData } from '../../../../../../../Helpers/webApi'
import SimpleTable from '../../../../../../../Components/Tables/SimpleTable'
import Loader from '../../../../../../../Components/Loaders/Loader'
function Guarantors({ selectedCreditInformationQuery }) {
  const [entries, setEntries] = useState([])
  const [reqParams, setReqParams] = useState({
    pageIndex: 0,
    pageSize: 10,
  })
  const [isBusy, setIsBusy] = useState(false)

  const loadEntries = async () => {
    setIsBusy(true)
    const { success, data } = await getData(
      `/CreditReferenceBureau/find-credit-information-query-quarantors`,
      {
        creditInformationQueryId: selectedCreditInformationQuery.id,
        ...reqParams,
      },
      false
    )
    if (success) {
      setEntries(data.pageCollection)
    } else {
      setEntries([])
    }
    setIsBusy(false)
  }

  useEffect(() => {
    loadEntries()
    // eslint-disable-next-line
  }, [
    selectedCreditInformationQuery?.id,
    reqParams.pageSize,
    reqParams.pageIndex,
  ])
  const columns = [
    {
      label: localize('accountNumber'),
      template: r => <>{r.accountNumber}</>,
    },
    {
      label: localize('identityNumber'),
      template: r => <>{r.identityNumber}</>,
    },
  ]
  return (
    <div>
      {isBusy ? (
        <Loader />
      ) : (
        <>
          <SimpleTable columns={columns} data={entries} />
        </>
      )}
    </div>
  )
}
export default Guarantors
